import React, { useState } from 'react';
import './DataWheel.css';

const cx = 250, cy = 250;
const outerR = 225, innerR = 105;

const segments = [
  { label: ["Data", "Architecture"],              colors: ["#1B3A6B", "#2A5298"] },
  { label: ["Data Modeling", "& Design"],         colors: ["#7BAED4", "#B0D0EC"] },
  { label: ["Data Storage", "& Operations"],      colors: ["#C8600A", "#F5A623"] },
  { label: ["Data", "Security"],                  colors: ["#7BAED4", "#B0D0EC"] },
  { label: ["Data Integration &", "Interoperability"], colors: ["#C8600A", "#F5A623"] },
  { label: ["Document &", "Content Mgmt"],        colors: ["#7BAED4", "#B0D0EC"] },
  { label: ["Reference &", "Master Data"],        colors: ["#1B3A6B", "#2A5298"] },
  { label: ["Data Warehousing", "& Business BI"], colors: ["#2E1A5E", "#4A3580"] },
  { label: ["Metadata"],                          colors: ["#1B3A6B", "#2A5298"] },
  { label: ["Data Quality"],                      colors: ["#C8600A", "#F5A623"] },
];

const toRad = (deg) => (deg * Math.PI) / 180;

const getPoint = (r, angleDeg) => ({
  x: cx + r * Math.cos(toRad(angleDeg)),
  y: cy + r * Math.sin(toRad(angleDeg)),
});

const buildPath = (startAngle, endAngle, outer, inner, expand = 0) => {
  const gap = 1.5;
  const s1 = getPoint(outer + expand, startAngle + gap);
  const e1 = getPoint(outer + expand, endAngle - gap);
  const s2 = getPoint(inner,          endAngle - gap);
  const e2 = getPoint(inner,          startAngle + gap);
  return `M ${s1.x} ${s1.y} A ${outer + expand} ${outer + expand} 0 0 1 ${e1.x} ${e1.y} L ${s2.x} ${s2.y} A ${inner} ${inner} 0 0 0 ${e2.x} ${e2.y} Z`;
};

const DataWheel = () => {
  const [hovered, setHovered] = useState(null);

  return (
    <svg viewBox="0 0 500 500" className="data-wheel-svg" aria-label="DAMA Data Governance Wheel">
      <defs>
        {segments.map((seg, i) => (
          <radialGradient key={i} id={`wg${i}`} cx="35%" cy="35%" r="70%">
            <stop offset="0%"   stopColor={seg.colors[1]} />
            <stop offset="100%" stopColor={seg.colors[0]} />
          </radialGradient>
        ))}
        <radialGradient id="centerGrad" cx="50%" cy="40%" r="60%">
          <stop offset="0%"   stopColor="#ffffff" />
          <stop offset="100%" stopColor="#e8eef8" />
        </radialGradient>
        <filter id="glowFx" x="-20%" y="-20%" width="140%" height="140%">
          <feGaussianBlur stdDeviation="5" result="blur" />
          <feMerge>
            <feMergeNode in="blur" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
        <filter id="shadowFx">
          <feDropShadow dx="0" dy="4" stdDeviation="8" floodColor="rgba(0,0,0,0.25)" />
        </filter>
      </defs>

      {/* Ombre globale */}
      <circle cx={cx} cy={cy} r={outerR + 6} fill="rgba(0,0,0,0.08)" filter="url(#shadowFx)" />

      {/* Segments */}
      {segments.map((seg, i) => {
        const startAngle = -90 + i * 36;
        const endAngle   = startAngle + 36;
        const midAngle   = startAngle + 18;
        const isHovered  = hovered === i;
        const textR      = (outerR + innerR) / 2 + 5;
        const textPos    = getPoint(textR, midAngle);

        return (
          <g
            key={i}
            className={`wheel-seg wheel-seg-${i}`}
            onMouseEnter={() => setHovered(i)}
            onMouseLeave={() => setHovered(null)}
            style={{ cursor: 'pointer' }}
          >
            <path
              d={buildPath(startAngle, endAngle, outerR, innerR, isHovered ? 10 : 0)}
              fill={`url(#wg${i})`}
              filter={isHovered ? 'url(#glowFx)' : ''}
              style={{
                transition: 'all 0.3s cubic-bezier(0.34,1.56,0.64,1)',
                opacity: hovered !== null && !isHovered ? 0.65 : 1,
              }}
            />
            {seg.label.map((line, li) => (
              <text
                key={li}
                x={textPos.x}
                y={textPos.y + (li - (seg.label.length - 1) / 2) * 13}
                textAnchor="middle"
                dominantBaseline="middle"
                fill="#ffffff"
                fontSize={isHovered ? "12" : "11"}
                fontWeight="700"
                fontFamily="Segoe UI, sans-serif"
                style={{ transition: 'font-size 0.2s', pointerEvents: 'none' }}
              >
                {line}
              </text>
            ))}
          </g>
        );
      })}

      {/* Centre */}
      <circle cx={cx} cy={cy} r={innerR - 4} fill="url(#centerGrad)" />
      <circle cx={cx} cy={cy} r={innerR - 4} fill="none" stroke="#d0daea" strokeWidth="1.5" />

      <text
        x={cx} y={cy - 14}
        textAnchor="middle" dominantBaseline="middle"
        fill="#1B3A6B" fontSize="22" fontWeight="800"
        fontFamily="Segoe UI, sans-serif"
      >
        Data
      </text>
      <text
        x={cx} y={cy + 14}
        textAnchor="middle" dominantBaseline="middle"
        fill="#1B3A6B" fontSize="22" fontWeight="800"
        fontFamily="Segoe UI, sans-serif"
      >
        Governance
      </text>
    </svg>
  );
};

export default DataWheel;